import { __read } from "tslib";
import React from 'react';
import { useDimeStore } from './../hooks';
import { DimeActionCreatorsContext, DimeStateContext } from './../store';
// TODO: May conditionally apply dime contexts after router is migrated out of context
export var DimeProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useDimeStore(), 2), dimeState = _b[0], actionCreators = _b[1];
    return (React.createElement(DimeStateContext.Provider, { value: dimeState },
        React.createElement(DimeActionCreatorsContext.Provider, { value: actionCreators }, children)));
};
//# sourceMappingURL=DimeProvider.js.map